var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 10C55.3137 10 58 12.6863 58 16L16 16L16 49.5294C12.6863 49.5294 10 46.8431 10 43.5294V16C10 12.6863 12.6863 10 16 10H52Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70L38 61.5294H28C24.6863 61.5294 22 58.8431 22 55.5294V28C22 24.6863 24.6863 22 28 22H64C67.3137 22 70 24.6863 70 28V55.5294C70 58.8431 67.3137 61.5294 64 61.5294H54L46 70ZM51.4137 55.5294L64 55.5294V28L28 28V55.5294H40.5863L46 61.2616L51.4137 55.5294Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.08965daf7fe372b9445d28aa6c8c7019.svg";
export { ForwardRef as ReactComponent };